import React from "react";

const Flag = ({flag}) => {
  return <img src={flag} alt="" className='flagImage' />;
};

export default Flag;
